import Adobe from '../../Images/Partner/Adobe.png';
import Autodesk from '../../Images/Partner/Autodesk.png';
import ibm from '../../Images/Partner/ibm.png';
import Hp from '../../Images/Partner/Hp.png';
import Microsoft from '../../Images/Partner/Microsoft.png';
import globus from '../../Images/Partner/globus.png';


const Content =[
    {
        id:1,
        image: Adobe,
        alt:"Adobe",
    },
    {
        id:2,
        image: Autodesk,
        alt:"Adobe",
    },
    {
        id:3,
        image: ibm,
        alt:"IBM",
    },
    {
        id:4,
        image: Hp,
        alt:"Adobe",
    },
    {
        id:5,
        image: globus,
        alt:"Globus",
    },

  
];
export default Content;